import { getDetail } from '@/api/global';
import { ensureAuth } from '@/utils/wxauth';
export default {
  data() {
    return {
      goods: {},
      show: false,
      shows: true
    };
  },
  created() {
    this.loadgetDetail();
  },
  methods: {
    onClickLeft() {
      history.back();
    },
    loadgetDetail() {
      // 先确保会话票据可用，再取明细；失效时 ensureAuth 会自动重新授权，
      // 回跳地址保留了 id，授权完还能回到同一张单据
      ensureAuth().then(auth => {
        if (!auth.ok) {
          console.log(auth.message);
          return;
        }
        getDetail({
          id: this.$route.query.id
        }).then(res => {
          if (res.data.status === 'success') {
            this.show = true;
            this.shows = false;
            this.goods = res.data.data;
          } else {
            console.log('获取数据失败');
          }
        }).catch(err => {
          console.log('失获取数据败', err);
        });
      });
    }
  }
};